import { useCallback } from "react";
import { useAsyncData } from "../../hooks/useAsyncData";
import { useCurrentUser } from "../../session/SessionContext";
import { trpc } from "../../trpc";
import { Card } from "../shared/Card";
import { EmptyState, LoadError, Loading } from "../shared/StatusViews";
import { InviteUserForm } from "./InviteUserForm";
import { UserRow } from "./UserRow";
import { useLayoutStyles } from "../shared/styles";

export const UsersPage = () => {
  const me = useCurrentUser();
  const layout = useLayoutStyles();
  const load = useCallback(
    (signal: AbortSignal) => trpc.user.list.query(undefined, { signal }),
    []
  );
  const users = useAsyncData(load);

  return (
    <div className={layout.sections}>
      <InviteUserForm onInvited={users.reload} />
      <Card title="Users">
        {users.error && (
          <LoadError message={users.error} onRetry={users.reload} />
        )}
        {users.loading && !users.data && <Loading />}
        {users.data?.length === 0 && <EmptyState title="No users yet" />}
        {users.data && users.data.length > 0 && (
          <ul className={layout.plainList}>
            {users.data.map((u) => (
              <UserRow
                key={u.id}
                user={u}
                isSelf={u.id === me.id}
                onChanged={users.reload}
              />
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
};
